'use client';

import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { stack } from '@/uiPrimitives/layout/stack';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { box } from '@/uiPrimitives/layout/box';
import { AutocompleteSuggestion } from './Autocomplete.types';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { icon } from '@/uiPrimitives/media/icon';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { textBlock } from '@/uiPrimitives/typography/text';
import { capitalizeFirstLetter } from '@/globals/helpers/string.helpers';
import { focusWithZIndex } from '@/uiPrimitives/base/focus.css';
const AutocompleteSuggestionItem = t0 => {
  const $ = _c(16);
  const {
    suggestion: t1
  } = t0;
  const {
    matchedBy,
    title,
    type,
    href
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = addTestSelector("uiAutocompleteSuggestionItem");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classes(shelf({
      alignItems: "center",
      gridTemplateColumns: "minmax(0, 1fr) auto"
    }), box({
      padding: "1 | h3",
      backgroundColor: "negative:hoverGray"
    }), focusWithZIndex);
    t4 = classes(stack({
      rowGap: "0 | p"
    }));
    t5 = classes(textBlock({
      textDecorationLine: "none",
      color: "positive:noHover"
    }));
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== matchedBy) {
    t6 = <p className={t5}>{matchedBy}</p>;
    $[4] = matchedBy;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== title || $[7] !== type) {
    t7 = (type || title) && <p className={classes(textBlock({
      capSize: "-1 | small",
      color: "positive:noHover",
      textDecorationLine: "none"
    }))}>{[type != null ? capitalizeFirstLetter(type) : "", title].join(" ")}</p>;
    $[6] = title;
    $[7] = type;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className={classes(occupy({
      inlineSize: "3 | h1"
    }))}><i className={classes(icon({
        icon: chevronIcon,
        blockSize: "0 | p",
        fill: "positiveBlue"
      }))} /></span>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== href || $[14] !== t8) {
    t10 = <li {...t2}><DOPLink href={href} data-link-type="transactionBlockSuggestionLink" className={t3}>{t8}{t9}</DOPLink></li>;
    $[13] = href;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export const AutocompleteSuggestions = t0 => {
  const $ = _c(10);
  const {
    suggestions
  } = t0;
  if (suggestions.length === 0) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(occupy({
      blockSize: "0px",
      inlineSize: "auto",
      alignItems: "start",
      justifyItems: "start"
    }));
    t2 = classes(stack({}), box({
      backgroundColor: "negative",
      inlineSize: "100%",
      borderStyle: "solid",
      borderColor: "positiveBlue",
      borderWidth: "1px"
    }));
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== suggestions) {
    t3 = suggestions.map(_temp);
    $[2] = suggestions;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <ul className={t2}>{t3}</ul>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(suggestion, i) {
  return <AutocompleteSuggestionItem key={`${suggestion.matchedBy}-${i}`} suggestion={suggestion} />;
}